import { FC, FormEvent, useEffect, useMemo, useState } from "react";
import { FaEye, FaEyeSlash, FaFilter, FaShareAlt, FaToggleOff, FaToggleOn } from "react-icons/fa";
import Select from "react-select";
import { createOptionListForSelectTag } from "../../../helpers/utils/Utils";
import { selectStyle } from "../../../helpers/utils/StyleUtils";
import { useGetEnumsQuery } from "../../../app/globalApi";
import SkeletonLoader from "../../../components/common/SkeletonLoader";
import { useDispatch } from "react-redux";
import { handleRTKQuery } from "../../../helpers/utils/RtkQueryUtils";
import { tgxApi } from "../../../app/tgxApi";
import ConfirmationModal from "../../../components/layout/modal/ConfirmationModal";
import {
    FaCircleInfo,
    FaDownload,
    FaTrash,
    FaTrashCanArrowUp, FaUpload
} from "react-icons/fa6";
import { getFileSizeFromBytes, toTitleCase, truncateText } from "../../../helpers/utils/TextUtils";
import AuditableInfo from "../../../components/common/AuditableInfo";
import ModalButton from "../../../components/common/form/ModalButton";
import VendorInfoModal from "../modal/VendorInfoModal";
import {
    useDeleteDocumentMutation, useGetOrderDocumentListQuery, useLazyViewFileQuery,
    useRestoreDocumentMutation,
    useUpdateDocumentVisibilityMutation
} from "../orderFilesApi";
import { useParams } from "react-router-dom";
import DocumentDeliverModal from "../modal/DocumentDeliverModal";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import ButtonTray from "../../../components/common/form/ButtonTray";
import { getEnumDisplayNameByConstant } from "../../../helpers/utils/EnumUtils";
import UploadDocumentModal from "../modal/UploadDocumentModal";

//@ts-ignore
import image from "../../../images/txt.svg";
import DocumentDownloadModal from "../modal/DocumentDownloadModal";

interface props {
    productId?: string | null,
    orderQuery: any
}

const OrderDocuments: FC<props> = ({ productId, orderQuery }) => {

    const dispatch = useDispatch();

    const { orderId } = useParams();

    const [show, setShowFilterList] = useState(false);
    const [includeDeletedFiles, setIncludeDeletedFiles] = useState(false);
    const { data: enums } = useGetEnumsQuery("")
    const [selectedTypes, setSelectedTypes] = useState<any[]>(["TaxCertificate", "HOAFull", "HOAContact", "NTP", "NOO", "INVOICE", "CADPrintout", "VendorRequest", "VendorResponse", "Other", "CombinedPDF", "MetesAndBounds", "PlatMap", "SOA", "SOA_REQUEST", "Commitment"])
    const [selectedFileId, setSelectedFileId] = useState("");

    const handleChange = (selectedOption: any[]) => {
        const selectedOptions = selectedOption?.map(c => c.value) || []
        setSelectedTypes(selectedOptions)
    };

    const [updateDocumentVisibility, { isLoading: isUpdateLoading }] = useUpdateDocumentVisibilityMutation()
    const [deleteDocument, { isLoading: isDeleteLoading }] = useDeleteDocumentMutation();
    const [restoreDocument, { isLoading: isRestoreLoading }] = useRestoreDocumentMutation();
    const [documentList, setDocumentList] = useState([]);
    const [viewFile] = useLazyViewFileQuery();
    const handleViewDownloadFile = async (fileToDownloadId: string, isDownload: boolean, isOpenInFrame: boolean) => {
        viewFile({ fileId: fileToDownloadId, isDownload: isDownload, isOpenInFrame: isOpenInFrame })
    }


    const [documentTypeList, setDocumentTypeList] = useState(["TaxCertificate", "HOAFull", "HOAContact", "NTP", "NOO", "INVOICE", "CADPrintout", "VendorRequest", "VendorResponse", "Other", "CombinedPDF", "MetesAndBounds", "PlatMap", "SOA", "SOA_REQUEST", "Commitment"]);

    const handleUpdateVisibilitySubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await handleRTKQuery(
            async () => {
                return await updateDocumentVisibility({ id: selectedFileId }).unwrap();
            },
            () => {
                dispatch(tgxApi.util.invalidateTags(["productDocumentList"]))
            }
        );
    }

    const handleDocumentDeleteSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        return deleteDocument({ id: selectedFileId });
    }

    const handleDocumentRestoreSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        return restoreDocument({ id: selectedFileId });
    }

    const {
        data: documents,
        isLoading: loading,
        isError: error,
    } = useGetOrderDocumentListQuery({
        orderId: orderId,
        orderFileType: selectedTypes,
    }, { skip: !orderId });


    const [markedFileList, setMarkedFileList] = useState<any>([]);

    useEffect(() => {

        if (orderQuery?.data?.products) {
            orderQuery?.data?.products.forEach((el: any) => {
                el?.markedFiles.forEach((id: any) => {
                    markedFileList.push(id);
                })
            })
        }
    }, [orderQuery]);
    useEffect(() => {
        if (documents?.error === undefined) {
            handleShowDeletedDocuments();
        }
    }, [documents, includeDeletedFiles]);

    const handleShowDeletedDocuments = () => {
        if (!includeDeletedFiles) {
            let list = documents?.filter((el: any) => {
                return el.deleted === false;
            });

            setDocumentList(list);
        } else {
            setDocumentList(documents);
        }
    }

    const iconButtonStyle = "cursor-pointer text-highlight-0 text-md hover:text-highlight-7";

    const filterOptionList = useMemo(() => createOptionListForSelectTag(enums?.OrderFileType, "value", "constant"),
        [enums]);

    return (
        <>
            <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mb-3 rounded-md mt-2">
                <div className="flex justify-between items-center border-b bordder border-surface-7 p-2">
                    <div className="text-surface-0 font-semibold flex gap-3">
                        Documents ({documentList?.length || 0})
                        <div className={"mt-1"}>
                            <FaFilter className={iconButtonStyle} onClick={() => {
                                setShowFilterList(!show)
                            }} />
                        </div>
                    </div>

                    <ButtonTray
                        buttons={[
                            {
                                buttonProps: {
                                    icon: <FaToggleOn className={iconButtonStyle} />,
                                    onClick: () => {
                                        setIncludeDeletedFiles(!includeDeletedFiles);
                                    },

                                    title: 'Hide Deleted Files',
                                    isVisible: includeDeletedFiles
                                },
                                buttonType: "icon",
                            },
                            {
                                buttonProps: {
                                    icon: <FaToggleOff className={iconButtonStyle} />,
                                    onClick: () => {
                                        setIncludeDeletedFiles(!includeDeletedFiles);
                                    },
                                    isVisible: !includeDeletedFiles,
                                    title: 'Show Deleted Files',

                                },
                                buttonType: "icon",
                            },
                            {
                                buttonProps: {
                                    modal: <DocumentDeliverModal
                                        show={true}
                                        setShow={() => {
                                        }}
                                        productId={productId}
                                        orderId={orderId}
                                        orderQuery={orderQuery}
                                    />,
                                    onOpen: () => {
                                    },
                                    triggerButton: <FaShareAlt className={iconButtonStyle} title='Deliver Documents' />,
                                    isVisible: hasPermission(["FILEDELIVER-V", "FILE-U"])
                                },
                                buttonType: "modal",
                            },
                            {
                                buttonProps: {
                                    modal: <UploadDocumentModal
                                        EnumType={"OrderFileType"} show={true}
                                        setShow={() => {
                                        }}
                                        customerOrderNumber={orderQuery?.data?.customerOrderNumber}
                                        documentTypeList={documentTypeList} orderSource={orderQuery?.data?.orderSource}
                                        relationalId={orderId}
                                        orderDTO={orderQuery.data}
                                        isOrderUpload={true}

                                    />,
                                    onOpen: () => {
                                    },
                                    triggerButton: <FaUpload className={iconButtonStyle} title='Upload Documents' />
                                    ,
                                    isVisible: hasPermission(["FILEUPLOAD-V", "FILE-U"])
                                },
                                buttonType: "modal",
                            },
                            {
                                buttonProps: {
                                    modal: <DocumentDownloadModal
                                        show={true}
                                        setShow={() => {
                                        }}
                                        productId={productId}
                                        orderId={orderId}
                                    />,
                                    onOpen: () => {
                                    },
                                    triggerButton: <FaDownload className={iconButtonStyle}
                                        title='Download Multiple Documents' />

                                },
                                buttonType: "modal",
                            }
                        ]}
                        align={"end"}
                        gap={4}

                    />
                </div>
                <div className={"p-2"}>
                    {
                        show && <Select
                            placeholder='Select filter options...'
                            isMulti={true}
                            options={filterOptionList}
                            value={filterOptionList.filter((option: any) => selectedTypes.includes(option.value))}
                            //@ts-ignore
                            onChange={handleChange}
                            styles={selectStyle}
                        />
                    }

                    <div className={'overflow-y-auto max-h-96'}>

                        {

                            (loading) ?
                                <SkeletonLoader className={"mt-2"} count={3} /> : error && !documents ?
                                    <div className="border-2 border-[rgba(0,0,0,0.1)] p-2 rounded-sm bg-text-0">
                                        <h3 className="text-surface-0">
                                            Unable to retrieve product documents, please try again in a few minutes
                                        </h3>
                                    </div>
                                    : documentList?.length === 0 ?
                                        <div className="border-2 border-[rgba(0,0,0,0.1)] p-2 rounded-sm bg-text-0">
                                            <h3 className="text-surface-0">
                                                No documents to display
                                            </h3>
                                        </div> :
                                        documentList?.map((data: any, index: number) => {
                                            return <div
                                                key={index}
                                                // className={`${data?.delivered && 'border-l-[#088001]'} sm:block md:flex justify-between  border-l-8 border-2 border-[rgba(0,0,0,0.1)] rounded-sm  py-2 px-2 ${data?.deleted ? "bg-[#DDDDDD]" : "bg-text-0"} `}>
                                                className={`${data?.delivered ? 'border-l-[#088001]' : markedFileList?.includes(data?.id) ? 'border-l-[#FFBF00]' : ''} sm:block md:flex justify-between border-l-8 border-2 border-[rgba(0,0,0,0.1)] rounded-sm py-2 px-2 ${data?.deleted ? "bg-[#DDDDDD]" : "bg-text-0"}`} >

                                                <div className="sm:block md:flex gap-2 items-start relative">
                                                    <div className={"mt-1"}>
                                                        {hasPermission(["FILE-U"]) && <ModalButton
                                                            triggerButton={data?.visibility ?
                                                                <FaEye className={iconButtonStyle} /> :
                                                                <FaEyeSlash
                                                                    className={iconButtonStyle} />}
                                                            onOpen={() => {
                                                                setSelectedFileId(data?.id)
                                                            }}
                                                            modal={
                                                                <ConfirmationModal
                                                                    show={true}
                                                                    setShow={() => {
                                                                    }}
                                                                    title={"Change Product Document Visibility"}
                                                                    bodyMessage={data?.visibility ? "Are you sure you want to make this document hidden to the customers ?" : "Are you sure you want to make this document visible to the customers ?"}
                                                                    onSubmit={handleUpdateVisibilitySubmit}
                                                                    isLoading={isUpdateLoading}
                                                                />
                                                            }
                                                        />}

                                                    </div>
                                                    <div>
                                                    
                                                            <div
                                                                className="text-ellipsis cursor-pointer text-highlight-5 hover:text-highlight-7"
                                                                onClick={() => {
                                                                    handleViewDownloadFile(data.id, false, true).then()
                                                                }}
                                                                title={data?.filename}>{truncateText(data?.filename, 48)}</div>
                                                            <div
                                                                className="text-text-2 italic">{getEnumDisplayNameByConstant(
                                                                    enums?.OrderFileType,
                                                                    data?.fileType
                                                                )} ({getFileSizeFromBytes(data?.fileSize, 0)})
                                                            </div>
                                                            <div className={""}>
                                                                <ButtonTray
                                                                    buttons={[

                                                                        {
                                                                            buttonProps: {
                                                                                icon: <FaDownload size={14}
                                                                                    className={iconButtonStyle} />,
                                                                                onClick: () => {
                                                                                    handleViewDownloadFile(data.id, true, false).then();
                                                                                },
                                                                                hasBackground: false,
                                                                                title: "Download document",
                                                                                className: "min-w-0 !justify-start w-auto mr-2"
                                                                            },
                                                                            buttonType: "icon",
                                                                        },
                                                                        {
                                                                            buttonProps: {
                                                                                modal: <ConfirmationModal
                                                                                    show={true}
                                                                                    setShow={() => {
                                                                                    }}
                                                                                    title={"Delete Document"}
                                                                                    bodyMessage={"Are you sure you want to delete this document ?"}
                                                                                    onSubmit={handleDocumentDeleteSubmit}
                                                                                    isLoading={isDeleteLoading}
                                                                                />,
                                                                                onOpen: () => {
                                                                                    setSelectedFileId(data?.id)
                                                                                },
                                                                                triggerButton: <FaTrash size={14}
                                                                                    className={iconButtonStyle}
                                                                                    title={"Delete document"} />,
                                                                                isVisible: !data?.deleted && hasPermission(["FILE-D"])
                                                                            },
                                                                            buttonType: "modal",
                                                                        },
                                                                        {
                                                                            buttonProps: {
                                                                                modal: <ConfirmationModal
                                                                                    show={true}
                                                                                    setShow={() => {
                                                                                    }}
                                                                                    title={"Restore Document"}
                                                                                    bodyMessage={"Are you sure you want to restore this product document ?"}
                                                                                    onSubmit={handleDocumentRestoreSubmit}
                                                                                    isLoading={isRestoreLoading}
                                                                                />,
                                                                                onOpen: () => {
                                                                                    setSelectedFileId(data?.id)
                                                                                },
                                                                                triggerButton: <FaTrashCanArrowUp
                                                                                    className={iconButtonStyle}
                                                                                    title={"Restore document"} />,
                                                                                isVisible: data?.deleted && hasPermission(["FILE-U"])
                                                                            },
                                                                            buttonType: "modal",
                                                                        }
                                                                    ]}
                                                                    align={"start"}
                                                                    gap={0}
                                                                />
                                                            </div>

                                                        </div>
                                              
                                                </div>
                                                    <AuditableInfo data={data} />
                                            </div>
                                        })}
                    </div>
                </div>
            </div>
        </>
    )
}
export default OrderDocuments;
